import { render, staticRenderFns } from "./LayoutBottom.vue?vue&type=template&id=7dc30f18&scoped=true&"
var script = {}
import style0 from "./LayoutBottom.vue?vue&type=style&index=0&id=7dc30f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc30f18",
  null
  
)

export default component.exports